<template>
  <v-dialog v-model="show" persistent max-width="500px">
    <v-card class="dialog-container">
      <v-container>
        <v-card-title primary-title>
          <div class="title-container">
            <span class="modal-title">{{ title }}</span>
            <v-icon
              class="modal-close-icon"
              @click="closeDialog()"
            >
              close
            </v-icon>
          </div>
        </v-card-title>

        <v-card-text>
          <text-field
            v-model="form.password"
            label="Password*"
            :error-messages="{
              required: 'This field is required.',
              maxLength: 'Maximum 30 characters allowed.',
              minLength: 'Enter at least 6 characters.',
            }"
            :append-icon="password ? 'content_copy' : ''"
            :validator="$v.form.password"
            @clickAppendIcon="$emit('onCopyPassword', form.password)"
          />

          <datetime-field
            v-model="form.expiresAt"
            style="padding-top: 6px"
            :validator="$v.form.expiresAt"
            :error-messages="{
              required: 'This field is required.',
            }"
            label="Ends date*"
          />
        </v-card-text>


        <v-card-actions>
          <div class="actions-container">
            <main-button
              v-if="password"
              flat
              depressed
              text="Delete"
              color="error"
              @click="$emit('onDeletePassword', password)"
            />
            <main-button
              :text="submitBtnLabel"
              color="primary"
              @click="submitForm"
            />
          </div>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import { date } from './../../validators'

export default {
  name: 'event-password-form-modal',
  props: {
    show: Boolean,
    title: String,
    password: {
      type: Object,
      default: () => null,
    },
  },
  emits: ['onCreate', 'onUpdate', 'update:show', 'onClearEditPassword', 'onDeletePassword', 'onCopyPassword'],
  data() {
    return {
      form: {
        id: this.password ? this.password.id : null,
        password: this.password ? this.password.password : '',
        expiresAt: this.password ? this.password.expiresAt : null,
      },
    }
  },
  validations() {
    return {
      form: {
        password: {
          required,
          minLength: minLength(6),
          maxLength: maxLength(30),
        },
        expiresAt: {
          required,
          date,
        },
      },
    }
  },
  computed: {
    submitBtnLabel() {
      return this.password ? 'Update' : 'Create password'
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit(this.password ? 'onUpdate' : 'onCreate', this.form)

      this.closeDialog()
    },
    closeDialog() {
      this.$emit('update:show', false)
      this.clearPasswordProp()
    },
    clearPasswordProp() {
      this.$emit('onClearEditPassword')
    },
  },
}
</script>

<style scoped>
.modal-close-icon {
  color: #979797;
  height: 13px;
  width: 13px;
}

.modal-title {
  color: #0277BD;
  font-weight: 600;
  font-size: 20px;
  font-family: 'Raleway', sans-serif;
}

.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.actions-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
